import React, { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import {useReactToPrint} from "react-to-print";
import html2pdf from 'html2pdf.js';
import moment from "moment";
import { ToWords } from "to-words";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as XLSX from 'xlsx';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { PostData } from "../../../../service/postData";
import { Loader } from "@progress/kendo-react-indicators";
import { QRCodeCanvas } from "qrcode.react";
import '../invoice.css';

const ExpenseInvoicePage = ({pdfRef, auth, isClickToGeneratePDF, isClickToPrint}) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [countryInt, setCountryInt] = useState('en-IN');
    const [currency, setCurrency] = useState('INR');
    const [businessSetting, setBusinessSetting] = useState({});
    const [theme, setTheme] = useState("");
    const [companyLogo, setCompanyLogo] = useState('');
    const [brandLogo, setBrandLogo] = useState('');
    const [settingTypeDisplay, setSettingTypeDisplay] = useState('');
    const [transportDetailField1, setTransportDetailField1] = useState('');
    const [transportDetailField2, setTransportDetailField2] = useState('');
    const [transportDetailField3, setTransportDetailField3] = useState('');
    const [transportDetailField4, setTransportDetailField4] = useState('');
    const [transportDetailField5, setTransportDetailField5] = useState('');
    const [transportDetailField6, setTransportDetailField6] = useState('');
    const [stateName, setStateName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companyAddress, setCompanyAddress] = useState('');
    const [companyPhone, setCompanyPhone] = useState('');
    const [companyEmail, setCompanyEmail] = useState('');
    const [firmAdditionalField1, setFirmAdditionalField1] = useState('Firm 1');
    const [firmAdditionalField2, setFirmAdditionalField2] = useState('Firm 2');
    const [firmAdditionalFieldValue1, setFirmAdditionalFieldValue1] = useState('');
    const [firmAdditionalFieldValue2, setFirmAdditionalFieldValue2] = useState('');
    const [companyGstin, setCompanyGstin] = useState('');
    const [companySignature, setCompanySignature] = useState('');
    const [additionalValue1, setAdditionalValue1] = useState('');
    const [additionalValue2, setAdditionalValue2] = useState('');
    const [additionalValue3, setAdditionalValue3] = useState('');
    const [additionalValueDate, setAdditionalValueDate] = useState('');
    const [transAdditionalCharge1, setTransAdditionalCharge1] = useState(0);
    const [transAdditionalCharge2, setTransAdditionalCharge2] = useState(0);
    const [transAdditionalCharge3, setTransAdditionalCharge3] = useState(0);
    const [poDate, setPoDate] = useState('');
    const [poNumber, setPoNumber] = useState('');
    const [dueOnDate, setDueOnDate] = useState('');
    const [EWayBillNo, setEWayBillNo] = useState('');
    const [invoiceTitle, setInvoiceTitle] = useState('');
    const [isCase, setIsCase] = useState(false);
    const [customerName, setCustomerName] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerPartyBalance, setCustomerPartyBalance] = useState(0);
    const [customerCompanyName, setCustomerCompanyName] = useState(0);
    const [customerShippingAddress, setCustomerShippingAddress] = useState('');
    const [partyAddFieldKey1, setPartyAddFieldKey1] = useState('');
    const [partyAddFieldValue1, setPartyAddFieldvalue1] = useState('');
    const [partyAddFieldKey2, setPartyAddFieldKey2] = useState('');
    const [partyAddFieldValue2, setPartyAddFieldvalue2] = useState('');
    const [partyAddFieldKey3, setPartyAddFieldKey3] = useState('');
    const [partyAddFieldValue3, setPartyAddFieldvalue3] = useState('');
    const [prefixName, setPrefixName] = useState('');
    const [invoiceNo, setInvoiceNo] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    const [invoiceTime, setInvoiceTime] = useState('');
    const [tableTitleSerialNo, setTableTitleSerialNo] = useState('');
    const [tableTitleItemName, setTableTitleItemName] = useState('');
    const [tableTitleHSNSAC, setTableTitleHSNSAC] = useState('');
    const [tableTitleItemCode, setTableTitleItemCode] = useState('');
    const [tableTitleQuantity, setTableTitleQuantity] = useState('');
    const [tableTitleUnit, setTableTitleUnit] = useState('');
    const [tableTitlePrice, setTableTitlePrice] = useState('');
    const [tableTitleTaxablePrice, setTableTitleTaxablePrice] = useState('');
    const [tableTitleDiscount, setTableTitleDiscount] = useState('');
    const [tableTitleAdditionalCESS, setTableTitleAdditionalCESS] = useState('');
    const [tableTitleTotalAmount, setTableTitleTotalAmount] = useState('');
    const [selectedItemArray, setSelectedItemArray] = useState([]);
    const [totalQty, setTotalQty] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [totalTransTax, setTotalTransTax] = useState(0);
    const [totalItemTax, setTotalItemTax] = useState(0);
    const [totalItemTaxPercentageList, setTotalItemTaxPercentageList] = useState([]);
    const [totalAddinalCESSAmt, setTotalAddinalCESSAmt] = useState(0);
    const [subtotal, setSubtotal] = useState(0);
    const [totalTax, setTotalTax] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [receivedAmount, setReceivedAmount] = useState(0);
    const [dueAmount, setDueAmount] = useState(0);
    const [totalTransDiscountPer, setTotalTransDiscountPer] = useState(0);
    const [totalTransDiscountAmount, setTotalTransDiscountAmount] = useState(0);
    const [transactionWiseTaxPercentage, setTransactionWiseTaxPercentage] = useState(0);
    const [transactionWiseTaxAmount, setTransactionWiseTaxAmount] = useState(0);
    const [paymentType, setPaymentType] = useState('');
    const [description, setDescription] = useState('');
    const [displayBankName, setDisplayBankName] = useState('');
    const [displayBankAccountNo, setDisplayBankAccountNo] = useState('');
    const [displayBankHolderName, setDisplayBankHolderName] = useState('');
    const [bankIfscCode, setBankIfscCode] = useState('');
    const [upiId, setUpiId] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
            
        if(isClickToGeneratePDF){
            clickToGeneratePDF();
        }else if(isClickToPrint){
            handlePrint();
        }
    }, [isClickToGeneratePDF, isClickToPrint]);
    
    useEffect(() => {
        let _UserSession = localStorage.getItem("vs_UserSession");
        let _companySession = localStorage.getItem("vs_UserCompanySession");
        let businessSetting = {};
        if (_UserSession != undefined || _UserSession != null) {
            if (_UserSession.loginType != "Admin") {
                _UserSession = JSON.parse(_UserSession);
                businessSetting = _UserSession.businessSetting;
                console.log('businessSetting', JSON.stringify(businessSetting));
                setBusinessSetting(businessSetting);
                setTableTitleSerialNo(businessSetting.si_no);
                setTableTitleItemName(businessSetting.item_name);
                setTableTitleHSNSAC(businessSetting.hsn_sac);
                setTableTitleItemCode(businessSetting.item_code);
                setTableTitleQuantity(businessSetting.quantity);
                setTableTitleUnit(businessSetting.unit);
                setTableTitlePrice(businessSetting.price_per_unit);
                setTableTitleTaxablePrice(businessSetting.taxable_price_per_unit);
                setTableTitleDiscount(businessSetting.discount);
                setTableTitleAdditionalCESS(businessSetting.addditional_cess);
                setTableTitleTotalAmount(businessSetting.total_amount);


            }
        }
        if (_companySession != undefined || _companySession != null) {
            _companySession = JSON.parse(_companySession);
            console.log('_companySession', JSON.stringify(_companySession));
            let _businessId = _companySession.business_id;
            let _company_id = _companySession.company_id;
            setCompanyName(_companySession.company_name);
            setCompanyAddress(_companySession.company_address);
            setCompanyPhone(_companySession.company_contact);
            setCompanyEmail(_companySession.email);
            setCompanyGstin(_companySession.gstin);
            setCompanySignature(_companySession.company_signature);
            setCurrency(_companySession.currency_code);
            setCountryInt('en-' + _companySession.country_short);

            let companyLogo = '';
            if (_companySession.company_logo.length > 6) {
                companyLogo = _companySession.company_logo;
            } else {
                companyLogo = global.LIVE_URL + "websiteFilesFolder/img/vyavsay.png";

            }
            imageToBase64(companyLogo, (base64) => {
                setCompanyLogo(base64);
            })
            getTransactionDetails(_companySession.bankDetails, businessSetting);
        }
        const brandLogo = global.webUrl + "websiteFilesFolder/img/logo.png";
        imageToBase64(brandLogo, (base64) => {
            setBrandLogo(base64);
        })

    }, []);


    const getTransactionDetails = (bankList, businessSetting) => {
        if (auth) {
            setIsLoading(true);
            const requestData = JSON.stringify({
                transaction_id: auth,
            });
            PostData(global.userExpenseTransactionDetails, requestData, "POST")
                .then((result) => {
                    setIsLoading(false);
                    let responseJson = result;
                    if (responseJson.success) {
                        let response = responseJson.response[0];
                        console.log('response', JSON.stringify(response));
                        let totalSummary = response.totalSummary;
                        let prefix = response.prefix;
                        let items = response.items;
                        let customer = response.customer;

                        setSelectedItemArray(items);
                        // Backend returns tax_value / discount_in_amount /
                        // Additional_CESS / gstAmount / totalTransTaxAmount as
                        // *strings* (they're VARCHAR columns). Plain `acc + x`
                        // in a reduce then concatenated strings ('0' + '0' =
                        // '00') and a single null/undefined field made the
                        // whole chain NaN — which is what surfaced as the
                        // "NaN"/blank amounts on the expense details page.
                        // Coerce each field with parseFloat + fallback so all
                        // arithmetic stays numeric.
                        const num = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };
                        let totalAdditionalCess = items.map((item) => num(item.Additional_CESS)).reduce((acc, x) => acc + x, 0);
                        let totalItemTaxPercentage = items.map((item) => {
                            return ({
                                rate: parseInt(item.tax_rate_ratio) || 0,
                                value: num(item.tax_value).toFixed(2)
                            })
                        });

                        let totalItemTax = items.map((item) => num(item.tax_value)).reduce((acc, x) => acc + x, 0);
                        let totalTax = totalItemTax + num(totalSummary.gstAmount) + totalAdditionalCess;


                        setTransactionWiseTaxPercentage(response.transactionWiseTaxPercentage);
                        setTransactionWiseTaxAmount(response.totalTransTaxAmount);
                        let transactionTax = {
                            rate: parseInt(response.transactionWiseTaxPercentage) || 0,
                            value: num(response.totalTransTaxAmount).toFixed(2)
                        }
                        setTotalItemTaxPercentageList([...totalItemTaxPercentage, transactionTax]);

                        setInvoiceTitle(businessSetting.ExpensesTransName);
                        setTotalAddinalCESSAmt(totalAdditionalCess);
                        setTotalTax(totalTax);
                        setTotalItemTax(totalItemTax);

                        let totalItemDiscount = items.map((item) => num(item.discount_in_amount)).reduce((acc, x) => acc + x, 0);
                        setTotalDiscount(totalItemDiscount);


                        setPrefixName(prefix.name);

                        setCustomerCompanyName((customer.billing_name && businessSetting.Tran_BillingNameParty == 1) ? customer.billing_name : customer.party_name);
                        let customerName = (customer.party_name && customer.party_name != 'NA') ? (customer.party_name + ' (' + customer.expense_category + ')') : customer.expense_category;
                        setCustomerName(customerName);
                        setCustomerPhone(customer.party_contact_no);
                        setCustomerAddress(response.billing_address);
                        setCustomerShippingAddress(customer.party_shipping_address);
                        setCustomerPartyBalance(customer.partyBalance);

                        setSettingTypeDisplay(response.settingType);
                        setInvoiceNo(response.invoiceNo);
                        setIsCase(response.isToggle);
                        setPoNumber(response.po_number);
                        setPoDate(response.po_date ? moment(response.po_date).format("DD MMM, YYYY") : moment().format("DD MMM, YYYY"));
                        setDueOnDate(response.dueOnDate ? moment(response.dueOnDate).format("DD MMM, YYYY") : moment().format("DD MMM, YYYY"));
                        setEWayBillNo(response.E_Way_Bill_No);
                        setInvoiceDate(moment(response.invoiceDate).format("DD MMM, YYYY"));
                        setInvoiceTime(response.invoice_time);
                        setStateName(response.countryState);
                        setFirmAdditionalField1(response.firm_additional_field1);
                        setFirmAdditionalFieldValue1(response.firm_additional_value1);
                        setFirmAdditionalField2(response.firm_additional_field2);
                        setFirmAdditionalFieldValue2(response.firm_additional_value2);
                        setPartyAddFieldKey1(response.party_add_field_key1);
                        setPartyAddFieldvalue1(response.party_add_field_value1);
                        setPartyAddFieldKey2(response.party_add_field_key3);
                        setPartyAddFieldvalue2(response.party_add_field_value2);
                        setPartyAddFieldKey3(response.party_add_field_key3);
                        setPartyAddFieldvalue3(response.party_add_field_value3);
                        setAdditionalValue1(response.additional_value_1);
                        setAdditionalValue2(response.additional_value_2);
                        setAdditionalValue3(response.additional_value_3);
                        setAdditionalValueDate(moment(response.additional_value_date).format("DD MMM, YYYY"));
                        setTransAdditionalCharge1(response.TransAdditionalCharge1);
                        setTransAdditionalCharge2(response.TransAdditionalCharge2);
                        setTransAdditionalCharge3(response.TransAdditionalCharge3);
                        setTransportDetailField1(response.TransportDetailField1 ? response.TransportDetailField1 : 'NA');
                        setTransportDetailField2(response.TransportDetailField2 ? response.TransportDetailField2 : 'NA');
                        setTransportDetailField3(response.TransportDetailField3 ? response.TransportDetailField3 : 'NA');
                        setTransportDetailField4(response.TransportDetailField4 ? response.TransportDetailField4 : 'NA');
                        setTransportDetailField5(response.TransportDetailField5 ? response.TransportDetailField5 : 'NA');
                        setTransportDetailField6(response.TransportDetailField6 ? response.TransportDetailField6 : 'NA');
                        setDescription(response.description);
                        setTotalTransDiscountPer(response.totalTransDiscountPer);
                        setTotalTransDiscountAmount(response.totalTransDiscountAmount);

                        setTotalQty(totalSummary.totalQty);
                        setTotalTransTax(totalSummary.gstAmount);
                        setSubtotal(totalSummary.subtotal);
                        setTotalAmount(totalSummary.totalAmount);
                        //setReceivedAmount(totalSummary.totalPaidAmount);
                        setReceivedAmount(parseFloat(totalSummary.paidAmount));
                        setDueAmount(totalSummary.dueAmount);

                        let _paymentType = response.paymentType;
                        if (_paymentType == "Bank") {
                            _paymentType = _paymentType + " - " + response.bankName + " (Ref No. - " + (response.paymentRefNo ? response.paymentRefNo : 'NA') + ")";

                        } else if (_paymentType == "Cheque") {
                            _paymentType = _paymentType + " - " + " (Ref No. - " + (response.paymentRefNo ? response.paymentRefNo : 'NA') + ")";

                        }
                        setPaymentType(_paymentType);
                        const _bankList = Array.isArray(bankList) ? bankList : [];
                        const selectedBank = _bankList.find(bank => bank.bank_id === response.bankId);

                        if (selectedBank) {
                            setDisplayBankName(selectedBank.bank_name2 || 'NA');
                            setDisplayBankAccountNo(selectedBank.bank_accountNumber || 'NA');
                            setDisplayBankHolderName(selectedBank.bank_accountHolderName || 'NA');
                            setBankIfscCode(selectedBank.ifscCode || 'NA');
                            setUpiId(selectedBank.upi_code || 'NA');
                        } else {
                            // Fallback: find bank with bank_print == 1
                            const fallbackBank = _bankList.find(bank => bank.bank_print === 1);
                            if (fallbackBank) {
                                setDisplayBankName(fallbackBank.bank_name2 || 'NA');
                                setDisplayBankAccountNo(fallbackBank.bank_accountNumber || 'NA');
                                setDisplayBankHolderName(fallbackBank.bank_accountHolderName || 'NA');
                                setBankIfscCode(fallbackBank.ifscCode || 'NA');
                            }

                            // UPI fallback: or_code_enable == 1
                            const upiFallback = _bankList.find(bank => bank.or_code_enable === 1);
                            if (upiFallback) {
                                setUpiId(upiFallback.upi_code || 'NA');
                            }
                        }

                    } else {
                        alert("Transaction details not found in system.");
                        window.location.href = global.webUrl + "business/expense/";
                    }
                })
                .catch((error) => {
                    setIsLoading(false)
                }
                );

        }
    }


    const imageToBase64 = (imageUrl, callback) => {
        fetch(imageUrl, {
            method: "GET",
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
            mode: 'cors'
        })
            .then((res) => res.blob())
            .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    callback(reader.result);
                };
                reader.readAsDataURL(blob);
            })
            .catch((error) => {
                console.error("Error fetching image:", error);
                callback(imageUrl);
            });
    };

    const getUpiId = () => {
        let name = displayBankHolderName == 'NA' ? displayBankName : displayBankHolderName;
        let amount = totalAmount;
        let upiString = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(name)}&mc=&tid=&tr=&tn=Payment&am=${amount}&cu=INR`;
        return upiString;
    }

    const toggleTheme = (themeName) => {
        document.documentElement.className = themeName;
        setTheme(themeName);
    };

    const numberFormat = (value) => {
        value = businessSetting.AmountWithDecimal == 1 ? parseFloat(value) : parseInt(Math.round(value))
        let amount = new Intl.NumberFormat(countryInt, {
            maximumFractionDigits: businessSetting.AmountWithDecimal == 1 ? 2 : 0,
            style: "currency",
            currency: currency //"INR"
        }).format(value);
        return amount;
    }

    const getAmountInWord = () => {
        return new ToWords({
            converterOptions: { ignoreDecimal: false },
        }).convert(totalAmount ? totalAmount : 0);
    }


    const handlePrint = useReactToPrint({
        content: () => pdfRef.current,
        documentTitle: invoiceTitle,
        pageStyle: `
        @page { size: auto;  margin: 10mm; } 
        body { margin: 10px; }
        `,
    });

    const clickToGeneratePDF = async () => {
            setIsLoading(true);
            let _currentDate = moment(new Date()).format("yyyy-MM-dd-hh-mm-ss");
            const printArea = document.getElementById("printArea");
            // Options for the PDF layout
            const options = {
                filename: invoiceTitle + _currentDate + ".pdf", // The name of the PDF file
                margin: [10, 10, 10, 10],    // Margins for the PDF content
                x: 10,                       // x position of the content
                y: 10,                       // y position of the content
                //image: { type: "jpeg", quality: 1 },
                html2canvas: {
                    scale: 2,                 // Higher scale for better quality
                    useCORS: true,
                    logging: true,            // Disable console logging
                    dpi: 192,                  // DPI setting for canvas rendering 192
                    letterRendering: true,     // Enable letter rendering for clearer text
                },
                jsPDF: {
                    unit: 'mm',                // Units for the PDF (millimeters)
                    format: 'a4',              // Use A4 page format (you can change it to 'letter' or custom sizes)
                    orientation: 'portrait',   // Orientation of the page (portrait or landscape)
                },
                //pagebreak: { mode: ["avoid-all", "css", "legacy"] },
            };
    
            // Generate the PDF from the HTML element
            //await html2pdf().from(printArea).set(options).save();
            await html2pdf().from(printArea).set(options).toPdf().get('pdf').then(function (pdf) {
                var totalPages = pdf.internal.getNumberOfPages();
                for (var i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                }
              }).save();
            setIsLoading(false);
        }

    const closeBtn = () => {
        window.location.href = global.webUrl + "business/sale-invoice/";
    }

    const getPriceWithTaxWithOutTax = (sale_tax_type, ratio, price) => {
        if (sale_tax_type == 'With Tax') {
            price = (price / (100 + ratio)) * 100;
        }

        return parseFloat(price).toFixed(2);
    }

    const isTransportationDetailsFieldEnable = () => {
        return (businessSetting.TransportationDetailsField1Enable == 1 ||
            businessSetting.TransportationDetailsField2Enable == 1 ||
            businessSetting.TransportationDetailsField3Enable == 1 ||
            businessSetting.TransportationDetailsField4Enable == 1 ||
            businessSetting.TransportationDetailsField5Enable == 1 ||
            businessSetting.TransportationDetailsField5Enable == 1)
    }

    return (
        <div style={{width: '100%'}}>
            <table id="printArea" ref={pdfRef} width={'100%'}>
                <tr>
                    <td>
                        <h4 className="invoice-title" style={{ color: "var(--text-color)" }}>
                            {invoiceTitle.toUpperCase()}
                        </h4>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table width={'100%'}>
                            <tr>
                                <td colSpan={2} style={{ textAlign: 'left' }}>
                                    {
                                        businessSetting.PrintOriginalDuplicate == 1 &&
                                        <>
                                            {
                                                settingTypeDisplay === "Original" ?
                                                    <ul>
                                                        <li
                                                            style={{
                                                                display: "inline",
                                                                listStyleType: "none",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    fontWeight: "400",
                                                                    marginLeft: "5px",
                                                                }}
                                                            >
                                                                Original for Recipient{" "}
                                                            </span>
                                                            <input type="checkbox" checked />
                                                        </li>
                                                    </ul>
                                                    :
                                                    (
                                                        settingTypeDisplay === "Duplicate" ?

                                                            <ul>
                                                                <li
                                                                    style={{
                                                                        display: "inline",
                                                                        listStyleType: "none",
                                                                    }}
                                                                >
                                                                    <span
                                                                    >
                                                                        Duplicate for Transporter{" "}
                                                                    </span>
                                                                    <input type="checkbox" checked />
                                                                </li>
                                                            </ul>
                                                            :
                                                            (
                                                                settingTypeDisplay === "Triplicate" ?
                                                                    <ul>
                                                                        <li
                                                                            style={{
                                                                                display: "inline",
                                                                                listStyleType: "none",
                                                                            }}
                                                                        >
                                                                            <span
                                                                            >
                                                                                Triplicate for Supplier{" "}
                                                                            </span>
                                                                            <input type="checkbox" checked />
                                                                        </li>
                                                                    </ul>
                                                                    :

                                                                    <ul>
                                                                        <li
                                                                            style={{
                                                                                display: "inline",
                                                                                listStyleType: "none",
                                                                            }}
                                                                        >
                                                                            <span
                                                                            >
                                                                                Original for Recipient &nbsp;
                                                                            </span>
                                                                            <input type="checkbox" checked />
                                                                            &nbsp; &nbsp; &nbsp;
                                                                        </li>
                                                                        <li
                                                                            style={{
                                                                                display: "inline",
                                                                                listStyleType: "none",
                                                                            }}
                                                                        >
                                                                            <span

                                                                            >
                                                                                Duplicate for Transporter &nbsp;
                                                                            </span>
                                                                            <input type="checkbox" checked />
                                                                            &nbsp; &nbsp; &nbsp;
                                                                        </li>
                                                                        <li
                                                                            style={{
                                                                                display: "inline",
                                                                                listStyleType: "none",
                                                                            }}
                                                                        >
                                                                            <span

                                                                            >
                                                                                Triplicate for Supplier &nbsp;
                                                                            </span>
                                                                            <input type="checkbox" checked />
                                                                        </li>
                                                                    </ul>

                                                            )
                                                    )


                                            }
                                        </>

                                    }
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    <div
                                        id="logo"
                                        style={{
                                            flex: "1",
                                            alignItems: "center",
                                            width: "250px",
                                            height: "150px",
                                            marginTop: "10px",
                                        }}
                                        onClick={() => { }}
                                    >

                                        {businessSetting.CompanyLogo == 1 && (
                                            <img
                                                src={companyLogo}
                                                style={{
                                                    maxWidth: "250px",
                                                    maxHeight: "150px",
                                                    borderRadius: "10px",
                                                }}
                                            />
                                        )}
                                    </div>
                                </td>
                                <td className="right-align" >

                                    {
                                        (businessSetting.PartyCompanyName == 1 ||
                                            businessSetting.Address == 1 ||
                                            businessSetting.PhoneNumber == 1 ||
                                            businessSetting.Email == 1 ||
                                            businessSetting.GSTINSale == 1) &&
                                        <p className={"headerTitle "}
                                            style={{ color: "var(--text-color)" }}
                                        >
                                            {" "}
                                            Company Details<br />
                                        </p>

                                    }

                                    {businessSetting.PartyCompanyName == 1 && (
                                        <p >
                                            Company Name : {companyName ? companyName : 'NA'}<br />
                                        </p>
                                    )}
                                    {businessSetting.Address == 1 && (
                                        <p>
                                            Company Address : {companyAddress ? companyAddress : 'NA'}<br />
                                        </p>
                                    )}
                                    {businessSetting.PhoneNumber == 1 && (
                                        <p

                                        >
                                            Company Phone no. : {companyPhone ? companyPhone : 'NA'}<br />
                                        </p>
                                    )}
                                    {businessSetting.Email == 1 && (
                                        <p

                                        >
                                            Company Email : {companyEmail ? companyEmail : 'NA'}<br />
                                        </p>
                                    )}

                                    {(businessSetting.GSTINSale == 1) && (
                                        <p

                                        >
                                            GSTIN : {companyGstin ? companyGstin : 'NA'}<br />
                                        </p>
                                    )}
                                    {(businessSetting.SateOfSupply == 1) &&
                                        <p >
                                            State Of Supply : {stateName ? stateName : 'NA'}<br />
                                        </p>
                                    }
                                    {
                                        businessSetting.firm_additional_showprint1 == 1 &&
                                        <p

                                        >
                                            {firmAdditionalField1} :{" "}
                                            {firmAdditionalFieldValue1}<br />
                                        </p>
                                    }
                                    {
                                        businessSetting.firm_additional_showprint2 == 1 &&
                                        <p

                                        >
                                            {firmAdditionalField2} :{" "}
                                            {firmAdditionalFieldValue2}<br />
                                        </p>
                                    }

                                    {
                                        businessSetting.TransactionAdditionalFieldSale > 0 &&
                                        <>
                                            {businessSetting.additional_field_check1 == 1 && (
                                                <p

                                                >
                                                    {businessSetting.additional_field_name1} :{" "}
                                                    {additionalValue1}<br />
                                                </p>
                                            )}
                                            {businessSetting.additional_field_check2 == 1 && (
                                                <p

                                                >
                                                    {businessSetting.additional_field_name2} :{" "}
                                                    {additionalValue2}<br />
                                                </p>
                                            )}
                                            {businessSetting.additional_field_check3 == 1 && (
                                                <p

                                                >
                                                    {businessSetting.additional_field_name3} :{" "}
                                                    {additionalValue3}<br />
                                                </p>
                                            )}
                                            {(businessSetting.additional_field_date_field_check == 1 || businessSetting.additional_field_date_field_check == true) && (
                                                <p

                                                >
                                                    {businessSetting.additional_field_date_field_name} :{" "}
                                                    {additionalValueDate}<br />
                                                </p>
                                            )}
                                        </>
                                    }
                                    {
                                        businessSetting.Tran_CustomerPO == 1 &&
                                        <p

                                        >
                                            PO Date : {poDate}<br />
                                        </p>
                                    }
                                    {
                                        poNumber &&
                                        <p

                                        >
                                            PO Number : {poNumber}<br />
                                        </p>
                                    }
                                    {
                                        businessSetting.DueDatesPaymentTerms == 1 &&
                                        <p

                                        >
                                            Due Date : {dueOnDate}<br />
                                        </p>
                                    }
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table width={'100%'} style={{ marginTop: "40px", border: "var(--border)" }}>
                            <th width={isTransportationDetailsFieldEnable() ? '33.3%' : '50%'} style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", textAlign: 'left', paddingLeft: '10px' }}>
                                <p >
                                    Bill To
                                </p>
                            </th>
                            {
                                isTransportationDetailsFieldEnable() &&
                                <th width={'33.3%'} style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", textAlign: 'left', paddingLeft: '10px' }}>
                                    <p >
                                        Transportation Details
                                    </p>
                                </th>
                            }
                            <th width={isTransportationDetailsFieldEnable() ? '33.3%' : '50%'} style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", textAlign: 'right', paddingRight: '10px' }}>
                                <p >
                                Expense Details
                                </p>
                            </th>
                            <tr >
                                <td style={{ padding: '10px', textAlign: 'left', border: "var(--border)" }}>
                                    <div>
                                        <p >
                                            {customerName}<br />
                                        </p>
                                        <p

                                        >
                                            {customerAddress ? customerAddress : 'NA'}<br />
                                        </p>
                                        <p

                                        >
                                            {customerPhone}<br />
                                        </p>
                                        {
                                            businessSetting.PartyPrintShippingAddress == 1 &&
                                            <p

                                            >
                                                {customerShippingAddress ? <><b>Shipping Add.:</b> {customerShippingAddress}</> : ''}<br />
                                            </p>
                                        }
                                        {businessSetting.PartyAddField1ShowPrint == 1 && (

                                            <p>
                                                <span>
                                                    {partyAddFieldKey1}   :  {partyAddFieldValue1}<br />
                                                </span>
                                            </p>

                                        )}
                                        {businessSetting.PartyAddField2ShowPrint == 1 && (

                                            <p
                                            >
                                                <span>
                                                    {partyAddFieldKey2}   :  {partyAddFieldValue2}<br />
                                                </span>
                                            </p>

                                        )}
                                        {businessSetting.PartyAddField3ShowPrint == 1 && (

                                            <p
                                            >
                                                <span>
                                                    {partyAddFieldKey3}   :  {partyAddFieldValue3}<br />
                                                </span>
                                            </p>

                                        )}
                                    </div>
                                </td>
                                {
                                    isTransportationDetailsFieldEnable() &&
                                    <td style={{ padding: '10px', textAlign: 'left', border: "var(--border)" }}>
                                        {businessSetting.TransportationDetailsField1Enable == 1 && (
                                            <p

                                            >
                                                {businessSetting.TransportationDetailsField1Name} :{" "}
                                                {transportDetailField1}<br />
                                            </p>
                                        )}
                                        {businessSetting.TransportationDetailsField2Enable == 1 && (
                                            <p

                                            >
                                                {businessSetting.TransportationDetailsField2Name} :{" "}
                                                {transportDetailField2}<br />
                                            </p>
                                        )}
                                        {businessSetting.TransportationDetailsField3Enable == 1 && (
                                            <p

                                            >
                                                {businessSetting.TransportationDetailsField3Name} :{" "}
                                                {transportDetailField3}<br />
                                            </p>
                                        )}
                                        {businessSetting.TransportationDetailsField4Enable == 1 && (
                                            <p

                                            >
                                                {businessSetting.TransportationDetailsField4Name} :{" "}
                                                {transportDetailField4}<br />
                                            </p>
                                        )}
                                        {businessSetting.TransportationDetailsField5Enable ==
                                            1 && (
                                                <p
                                                >
                                                    {businessSetting.TransportationDetailsField5Name} :{" "}
                                                    {transportDetailField5}<br />
                                                </p>
                                            )}
                                        {businessSetting.TransportationDetailsField6Enable ==
                                            1 && (
                                                <p
                                                >
                                                    {businessSetting.TransportationDetailsField6Name} :{" "}
                                                    {transportDetailField6}<br />
                                                </p>
                                            )}
                                    </td>
                                }
                                <td style={{ padding: '10px', border: "var(--border)", textAlign: 'right' }}>
                                    <p >
                                        <b>No.: </b> {(prefixName && prefixName != 'None') ? '(' + prefixName + ')' : ''} {invoiceNo}<br />
                                    </p>
                                    <p >
                                        <b>Date </b> {(businessSetting.Tran_AddTime && businessSetting.Tran_AddTimePrint == 1) ?( <b>& Time : </b>) : ': '}
                                        {invoiceDate} {(businessSetting.Tran_AddTime && businessSetting.Tran_AddTimePrint == 1) ? invoiceTime : ''}<br />
                                    </p>
                                </td>

                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table width={'100%'} style={{ border: "var(--border)" }}>
                            <tr style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)" }}>
                                {businessSetting.si_enable == 1 && (
                                    <th
                                        style={{
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleSerialNo}
                                    </th>
                                )}

                                <th
                                    style={{
                                        color: "#FFFFFF",
                                        textAlign: "center",
                                        fontFamily: "Arial",
                                        //lineHeight: '24px',
                                        padding: "3px",
                                    }}
                                >
                                    {tableTitleItemName}
                                </th>

                                {businessSetting.hsn_sac_enable == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleHSNSAC}
                                    </th>
                                )}

                                {businessSetting.item_code_enabled == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleItemCode}
                                    </th>
                                )}
                                {businessSetting.Count == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        Count
                                    </th>
                                )}

                                {businessSetting.quantity_enable == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleQuantity}
                                    </th>
                                )}
                                {businessSetting.unit_enabled == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleUnit}
                                    </th>
                                )}

                                {businessSetting.price_per_unit_enabled == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitlePrice}
                                    </th>
                                )}
                                {businessSetting.taxable_price_per_unit_enabled == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleTaxablePrice}
                                    </th>
                                )}

                                {businessSetting.discount_enable == 1 && (
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleDiscount}
                                    </th>
                                )}
                                {
                                    businessSetting.tax_amount_enable == 1 &&
                                    <th
                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        TAX
                                    </th>
                                }


                                {businessSetting.AdditionalCESS == 1 && (
                                    <th

                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleAdditionalCESS}
                                    </th>
                                )}

                                {businessSetting.total_amount_enable == 1 && (
                                    <th

                                        style={{
                                            color: "#FFFFFF",
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                    >
                                        {tableTitleTotalAmount}
                                    </th>
                                )}
                            </tr>
                            {selectedItemArray.map((value, index) => {

                                let _free_quantity = "";
                                if (
                                    businessSetting.FreeItemQuantity == 1 &&
                                    value.free_quantity > 0
                                ) {
                                    _free_quantity = " + " + value.free_quantity;
                                }
                                let _gstRatio = "";
                                if (businessSetting.tax_percentage_enable == 1) {
                                    _gstRatio = "(" + (value.tax_type.ratio ? value.tax_type.ratio : 0) + " %)";
                                }


                                return (
                                    <tr key={index} style={{ border: "var(--border)" }}>
                                        {businessSetting.si_enable == 1 && (
                                            <td
                                                style={{
                                                    fontFamily: "Arial",
                                                    lineHeight: "24px",
                                                    alignContent: 'flex-start',
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {index + 1}
                                            </td>
                                        )}
                                        <td
                                            style={{
                                                fontFamily: "Arial",
                                                textAlign: "center",
                                                lineHeight: "24px",
                                                border: "var(--border)"
                                            }}
                                        >
                                            <span>{value.name}</span><br />
                                            {value.trackingType == 'Batch' && value.selectedData.map(
                                                (batchDataLoop, index) => {
                                                    return (
                                                        <div key={index}>
                                                            {businessSetting.batch_tracking_enable ===
                                                                1 && (
                                                                    <span>
                                                                        {businessSetting.BatchNoTxt}{" "}
                                                                        : {batchDataLoop.batch_no}
                                                                    </span>
                                                                )}
                                                        </div>
                                                    );
                                                }
                                            )}

                                            {value.trackingType == 'Serial' && value.selectedData.map(
                                                (serialDataLoop, index) => {
                                                    return (
                                                        <div key={index}>
                                                            {serialDataLoop.serial_no != "" && (
                                                                businessSetting.serial_tracking_enabled ===
                                                                1 && (
                                                                    <>
                                                                        {serialDataLoop.serial_no !=
                                                                            "" && (
                                                                                <span>
                                                                                    {" "}
                                                                                    {
                                                                                        businessSetting.SerialNoTxt
                                                                                    }{" "}
                                                                                    : {serialDataLoop.serial_no}
                                                                                </span>
                                                                            )}
                                                                        <br />
                                                                        {businessSetting.SerialNoAdditionalLabel1 !==
                                                                            "" && (
                                                                                <span>
                                                                                    {
                                                                                        businessSetting.SerialNoAdditionalLabel1
                                                                                    }{" "}
                                                                                    :{" "}
                                                                                    {
                                                                                        serialDataLoop.serialNoAdditionalValue1
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                        <br />
                                                                        {businessSetting.SerialNoAdditionalLabel2 !==
                                                                            "" && (
                                                                                <span>
                                                                                    {
                                                                                        businessSetting.SerialNoAdditionalLabel2
                                                                                    }{" "}
                                                                                    :{" "}
                                                                                    {
                                                                                        serialDataLoop.serialNoAdditionalValue2
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                        <br />
                                                                    </>
                                                                )
                                                            )}
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </td>

                                        {businessSetting.hsn_sac_enable == 1 && (
                                            <td
                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {value.hsn_sac}
                                            </td>
                                        )}

                                        {businessSetting.item_code_enabled === 1 && (
                                            <td
                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {value.code}
                                            </td>
                                        )}

                                        {businessSetting.Count == 1 && (
                                            <td
                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {value.trans_count}
                                            </td>
                                        )}
                                        {businessSetting.quantity_enable == 1 && (
                                            <td
                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {value.quantity ? value.quantity : 0}{" "}
                                                {(businessSetting.FreeItemQuantity == 1 ||
                                                    businessSetting.FreeItemQuantity == "1") &&
                                                    _free_quantity
                                                    ? "  " + _free_quantity
                                                    : ""}
                                            </td>
                                        )}

                                        {(businessSetting.unit_enabled == 1) && (
                                            <td
                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {value.unit.unit_name ? value.unit.unit_name : "NA"}
                                            </td>
                                        )}

                                        {businessSetting.price_per_unit_enabled == 1 && (
                                            <td

                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {numberFormat(value.rate)}
                                            </td>
                                        )}
                                        {businessSetting.taxable_price_per_unit_enabled == 1 && (
                                            <td

                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {numberFormat(getPriceWithTaxWithOutTax(value.sale_tax_type, parseInt(value.tax_rate_ratio), value.rate))}
                                            </td>
                                        )}

                                        {businessSetting.discount_enable == 1 && (
                                            <td

                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {numberFormat(value.discount_in_amount)}
                                                {/* +' ('+value.discountPer +'%)' */}
                                                {businessSetting.discount_percentage_enable ===
                                                    1 && <span>({value.discount_in_per + "%"})</span>}
                                            </td>
                                        )}
                                        {
                                            businessSetting.tax_amount_enable == 1 &&
                                            <td

                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {numberFormat(value.tax_value) + _gstRatio}

                                            </td>
                                        }

                                        {businessSetting.AdditionalCESS == 1 && (
                                            <td

                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",
                                                    border: "var(--border)"
                                                }}
                                            >
                                                {numberFormat(value.Additional_CESS)}
                                            </td>
                                        )}
                                        {businessSetting.total_amount_enable == 1 && (
                                            <td

                                                style={{
                                                    fontFamily: "Arial",
                                                    textAlign: "center",
                                                    color: "#333333",
                                                    lineHeight: "24px",

                                                }}
                                            >
                                                {numberFormat(value.total_amount)}
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                            {businessSetting.TotalItemQuantity == 1 && (
                                <tr
                                    style={{
                                        fontFamily: "Arial",
                                        textAlign: "center",
                                        lineHeight: "24px",
                                        border: "var(--border)",
                                    }}
                                >
                                    {businessSetting.si_enable == 1 && <td></td>}
                                    <td>
                                        <b>Total</b>
                                    </td>
                                    {businessSetting.hsn_sac_enable == 1 && <td></td>}
                                    {businessSetting.item_code_enabled == 1 && <td></td>}
                                    {businessSetting.Count > 0 && (
                                        <td></td>
                                    )}
                                    {businessSetting.quantity_enable == 1 && (
                                        <td>
                                            <b>{totalQty}</b>
                                        </td>
                                    )}
                                    {businessSetting.unit_enabled == 1 && <td></td>}
                                    {businessSetting.price_per_unit_enabled == 1 && (
                                        <td></td>
                                    )}
                                    {businessSetting.taxable_price_per_unit_enabled == 1 && (
                                        <td></td>
                                    )}
                                    {businessSetting.discount_enable == 1 && (
                                        <td>
                                            <b>{numberFormat(totalDiscount)}</b>
                                        </td>
                                    )}
                                    {businessSetting.tax_amount_enable == 1 &&
                                        <td>
                                            <b>{numberFormat(totalItemTax)}</b>
                                        </td>
                                    }
                                    {businessSetting.AdditionalCESS == 1 && (
                                        <td>
                                            <b>{numberFormat(totalAddinalCESSAmt)}</b>
                                        </td>
                                    )}
                                    {businessSetting.total_amount_enable == 1 && (
                                        <td>
                                            <b>{numberFormat(subtotal)}</b>
                                        </td>
                                    )}
                                </tr>
                            )}
                        </table>
                    </td>
                </tr>
                <tr>
                    <td >
                        <table width={'100%'} style={{ border: "var(--border)" }} >
                            <tr >
                                <th width={'50%'} style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", textAlign: 'center' }}>
                                    <p >
                                        Total Amount In Words
                                    </p>
                                </th>
                                <th width={'50%'} style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", textAlign: 'center' }}>
                                    <p >
                                        Amounts
                                    </p>
                                </th>
                            </tr>
                            <tr>
                                <table width={'100%'}>
                                    <tr>
                                        <td style={{ padding: '5px', textAlign: 'center' }}>
                                            <p >
                                                {getAmountInWord()} Only
                                            </p>
                                        </td>
                                    </tr>
                                    {businessSetting.PaymentMode == 1 &&
                                        <>
                                            <tr style={{ border: "var(--border)" }}>
                                                <th style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", textAlign: 'center' }}>
                                                    <p >
                                                        Payment Mode
                                                    </p>
                                                </th>
                                            </tr>
                                            <tr >
                                                <td style={{ textAlign: 'center' }}>
                                                    {paymentType}
                                                </td>
                                            </tr>
                                        </>
                                    }
                                </table>
                                <td>
                                    <table width={'100%'}>
                                        <tr style={{ border: "var(--border)" }}>
                                            <td style={{ padding: '5px', textAlign: 'left' }}>
                                                <p >
                                                    Subtotal
                                                </p>
                                            </td>
                                            <td style={{ padding: '5px', textAlign: 'right' }}>
                                                <p >
                                                    {numberFormat(subtotal)}
                                                </p>
                                            </td>
                                        </tr>
                                        {businessSetting.TransactionWiseDiscount == 1 && (
                                            <tr style={{ border: "var(--border)" }}>
                                                <td style={{ padding: '5px', textAlign: 'left' }}>
                                                    Discount ({totalTransDiscountPer}%)
                                                </td>
                                                <td style={{ padding: '5px', textAlign: 'right' }}>
                                                    {numberFormat(totalTransDiscountAmount)}
                                                </td>
                                            </tr>
                                        )}
                                        {
                                            businessSetting.TransactionAdditionalChargeEnable == 1 &&
                                            <>
                                                {
                                                    businessSetting.TransactionAdditionalCharge1Enable == 1 && parseFloat(transAdditionalCharge1) > 0 &&
                                                    <tr style={{ border: "var(--border)" }}>
                                                        <td style={{ padding: '5px', textAlign: 'left' }}>
                                                            {businessSetting.TransactionAdditionalCharge1Name}
                                                        </td>
                                                        <td style={{ padding: '5px', textAlign: 'right' }}>
                                                            {numberFormat(transAdditionalCharge1)}
                                                        </td>
                                                    </tr>
                                                }
                                                {
                                                    businessSetting.TransactionAdditionalCharge2Enable == 1 && parseFloat(transAdditionalCharge2) > 0 &&
                                                    <tr style={{ border: "var(--border)" }}>
                                                        <td style={{ padding: '5px', textAlign: 'left' }}>
                                                            {businessSetting.TransactionAdditionalCharge2Name}
                                                        </td>
                                                        <td style={{ padding: '5px', textAlign: 'right' }}>
                                                            {numberFormat(transAdditionalCharge2)}
                                                        </td>
                                                    </tr>
                                                }
                                                {
                                                    businessSetting.TransactionAdditionalCharge3Enable == 1 && parseFloat(transAdditionalCharge3) > 0 &&
                                                    <tr style={{ border: "var(--border)" }}>
                                                        <td style={{ padding: '5px', textAlign: 'left' }}>
                                                            {businessSetting.TransactionAdditionalCharge3Name}
                                                        </td>
                                                        <td style={{ padding: '5px', textAlign: 'right' }}>
                                                            {numberFormat(transAdditionalCharge3)}
                                                        </td>
                                                    </tr>
                                                }
                                            </>
                                        }
                                        <tr style={{ border: "var(--border)" }}>
                                            <td style={{ padding: '5px', textAlign: 'left' }}>
                                                Total
                                            </td>
                                            <td style={{ padding: '5px', textAlign: 'right' }}>
                                                {numberFormat(totalAmount)}
                                            </td>
                                        </tr>
                                        {businessSetting.ReceivedAmount == 1 &&
                                            <tr style={{ border: "var(--border)" }}>
                                                <td style={{ padding: '5px', textAlign: 'left' }}>
                                                    Received Amount
                                                </td>
                                                <td style={{ padding: '5px', textAlign: 'right' }}>
                                                    {numberFormat(receivedAmount)}
                                                </td>
                                            </tr>
                                        }
                                        {businessSetting.BalanceAmount == 1 &&
                                            <tr style={{ border: "var(--border)" }}>
                                                <td style={{ padding: '5px', textAlign: 'left' }}>
                                                    Balance Due
                                                </td>
                                                <td style={{ padding: '5px', textAlign: 'right' }}>
                                                    {numberFormat(dueAmount)}
                                                </td>
                                            </tr>
                                        }
                                        {/* {businessSetting.PrintCurrentBalanceParty == 1 && (
                                            <tr style={{ border: "var(--border)" }}>
                                                <td style={{ padding: '5px', textAlign: 'left' }}>
                                                    Current Balance
                                                </td>
                                                <td style={{ padding: '5px', textAlign: 'right' }}>
                                                    {numberFormat(customerPartyBalance)}
                                                </td>
                                            </tr>
                                        )} */}
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", border: "1px solid white", textAlign: 'center' }}>
                                <tr>
                                    {
                                        (displayBankName || upiId) &&
                                        <th style={{ width: "33.3%" }}>Bank Details</th>
                                    }
                                    {
                                        businessSetting.PrintDescription == 1 &&
                                        <th style={{ width: "50%", textAlign: "left", backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", border: "1px solid white", textAlign: 'center' }}>
                                            Description
                                        </th>
                                    }
                                    {
                                        businessSetting.PrintSignatureText == 1 &&
                                        <th style={{ width: "33.3%" }}>For : {companyName}</th>
                                    }
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    {(displayBankName || upiId) && (
                                                          <td style={{ border: "var(--border)" }}>
                                                            <table
                                                              style={{ width: "100%", borderCollapse: "collapse" }}
                                                            >
                                                              <tbody>
                                                                <tr>
                                                                  <td>
                                                                    {upiId && (
                                                                      <div style={{ marginTop: "20px" }}>
                                                                        <div>
                                                                          <QRCodeCanvas
                                                                            value={getUpiId()}
                                                                            size={80}
                                                                          />
                                                                          <p>{upiId}</p>
                                                                        </div>
                                                                      </div>
                                                                    )}
                                                                  </td>
                                                                  <td>
                                                                    {displayBankName && (
                                                                      <p>
                                                                        Bank Name: {displayBankName}
                                                                        <br />
                                                                        Account number: {displayBankAccountNo}
                                                                        <br />
                                                                        IFSC Code: {bankIfscCode}
                                                                      </p>
                                                                    )}
                                                                  </td>
                                                                </tr>
                                                              </tbody>
                                                            </table>
                                                          </td>
                                                        )}
                                    
                                    {       
                                        businessSetting.PrintDescription == 1 &&
                                        <td style={{ border: "var(--border)", textAlign: 'center' }}>{description ? description : 'NA'}</td>
                                    }
                                    {
                                        businessSetting.PrintSignatureText == 1 &&
                                        <td style={{ width: "33.3%", textAlign: 'center', border: "var(--border)" }}>
                                            {companySignature.length > 15 && (
                                                <img src={companySignature} height="100" width="100" />
                                            )}
                                            <p><b>Authorised Signature</b></p>
                                        </td>
                                    }

                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr><td height="40"></td></tr>
                <tr>
                    <td>
                        <div stlye={{ height: "100px !important", width: "100px !important", display: "block" }} id="logo">
                            <img src={brandLogo} alt="" title="" style={{ maxWidth: "200px" }} />
                        </div>
                    </td>
                </tr>
                <tr><td height="40"></td></tr>
                <tr>
                    <td>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <i className="fa fa-scissors"></i>
                            <div style={{ flexGrow: 1, borderBottom: "2px dashed var(--theme-bg)" }} />
                        </div>
                    </td>
                </tr>
                {
                    businessSetting.PrintAcknowledgement == 1 &&
                    <>
                        <tr>
                            <td>
                                <table style={{ width: "100%", }}>

                                    <tbody>
                                        <tr>
                                            <td >
                                                <table style={{ width: "100%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: "33.3%" }}>
                                                                {customerCompanyName}<br />
                                                                {customerAddress}<br />
                                                            </td>
                                                            <td style={{ width: "33.3%", textAlign: 'center' }}>
                                                                Acknowledgement<br />
                                                                {companyName}<br />
                                                            </td>
                                                            <td style={{ width: "33.3%", textAlign: 'right' }}>
                                                                <b>Expense No :</b> {invoiceNo}<br />
                                                                <b>Expense Date :</b> {invoiceDate}<br />
                                                                <b>Expense Amount :</b> {numberFormat(totalAmount)}<br />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td height="100">
                                &nbsp;
                            </td>
                        </tr>
                        <tr >
                            <td className="right-center">
                                <p>&nbsp;&nbsp;</p>
                                <p><b>Receiver's Seal & Sign</b></p>
                            </td>
                        </tr>
                    </>
                }
            </table>
            {
                isLoading && (
                    <Dialog >
                        <Loader type="converging-spinner" />
                    </Dialog>
                )
            }
        </div>
    )
}
export default ExpenseInvoicePage;